enum FolderOptionValue {
  TogglePin = 'togglePin',
  Edit = 'edit',
  Remove = 'remove',
  ShareUrl = 'shareUrl',
}

export default FolderOptionValue;
